import React from "react";
import "./Photos.css";

export default function Photos(props) {
  if (props.photos) {
    return (
      <section className="Photos mt-5 ">
        <div className="row">
          {props.photos.map(function (photo, index) {
            console.log(photo);
            return (
              <div className="col-4" key={index}>
                <a
                  className="photosLink"
                  href={photo.src.original}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img alt="img" src={photo.src.tiny} className="img-fluid" />
                </a>
              </div>
            );
          })}
        </div>
      </section>
    );
  } else {
    return null;
  }
}
